
export default {
  name: "PricingTabsButtons",
  data() {
    return {
      tabStep: 1,
    }
  },
  props: ['step'],
  methods: {
    change(tab) {
      this.$emit('change', tab);
    }
  }
}
